import Guid from "common/values/guid/guid";
import WorkVendorRepresentativeAPIResponse
  from "work/entities/entity-vendor-representative/api/response-contracts/work-vendor-representative-api-response";
import VendorTeam from "work/values/vendor-team/vendor-team";
import SimpleEntityMemberApiResponse
  from "../../../entity-member/api/response-contracts/simple-entity-member-api-response";
import EntityMember from "work/values/entity-member/entity-member";

export default class SimpleWorkVendorTeamAPIResponse {
  leader?: WorkVendorRepresentativeAPIResponse;
  members?: SimpleEntityMemberApiResponse[];
  marketplaceId?: string;

  deserialize(): VendorTeam {
    return new VendorTeam(
      this.leader ? Object.assign(
        new WorkVendorRepresentativeAPIResponse(),
        this.leader
      ).deserialize() : undefined,
      this.members?.map(member => Object.assign(
        new SimpleEntityMemberApiResponse(), member).deserialize()
      ).filter(member => member.userId && member.entityId).map(member => new EntityMember(member.userId, member.entityId!)) ?? [],
      this.marketplaceId ? new Guid(this.marketplaceId) : undefined
    );
  }
}
